const STEP_LABEL_TOKEN_REGEX = /\b(bioRxiv|ClinicalTrials|PubMed|openFDA)\b|\b(\d+\s+results)\b/g;

const TEXT_BEFORE_COLON_RE = /^([^<:]+)(:)(?=\s*\S)/;

const escapeHtml = (value) =>
  String(value ?? '').replace(/[&<>"']/g, (character) => {
    switch (character) {
      case '&':
        return '&amp;';
      case '<':
        return '&lt;';
      case '>':
        return '&gt;';
      case '"':
        return '&quot;';
      case "'":
        return '&#39;';
      default:
        return character;
    }
  });

export const STEP_LABEL_STATE = {
  running: 'running',
  done: 'done',
  failed: 'failed',
  pending: 'pending',
};

export const formatStepLabelHtml = (label, state = STEP_LABEL_STATE.pending) => {
  const text = String(label ?? '');

  if (!state) {
    return `<span class="step-label">${escapeHtml(text)}</span>`;
  }

  if (state === STEP_LABEL_STATE.running) {
    return `<span class="step-label step-label--running">${escapeHtml(text)}</span>`;
  }

  let html = '';
  let lastIndex = 0;

  text.replace(STEP_LABEL_TOKEN_REGEX, (match, _sourceName, _resultCount, offset) => {
    html += escapeHtml(text.slice(lastIndex, offset));
    html += `<span class="step-label__token">${escapeHtml(match)}</span>`;
    lastIndex = offset + match.length;
    return match;
  });

  html += escapeHtml(text.slice(lastIndex));

  return `<span class="step-label step-label--muted">${html}</span>`;
};

export const formatIdleStepLabel = (html) => {
  // Skip any leading HTML tags iteratively to avoid nested-quantifier ReDoS
  let pos = 0;
  while (pos < html.length && html[pos] === '<') {
    const close = html.indexOf('>', pos);
    if (close === -1) break;
    pos = close + 1;
  }
  const tagPrefix = html.slice(0, pos);
  const rest = html.slice(pos);
  const match = TEXT_BEFORE_COLON_RE.exec(rest);
  if (match) {
    return tagPrefix + '<strong>' + match[1] + '</strong>' + match[2] + rest.slice(match[0].length);
  }

  return html.replace(STEP_LABEL_TOKEN_REGEX, '<strong class="tool-step-token">$&</strong>');
};
